// plugins/directives.js
import Vue from 'vue';
import DOMPurify from 'dompurify';

// 允许 Vue 特定属性
// DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
//   if (data.attrName.startsWith('v-') || data.attrName.startsWith('@') || data.attrName.startsWith(':')) {
//     return data.attrName; // 保留 Vue 指令
//   }
// });

Vue.directive('compile', {
  bind(el, binding, vnode) {
    compileDynamicContent(el, binding.value, vnode.context);
  },
  update(el, binding, vnode) {
    if (binding.oldValue !== binding.value) {
      destroyOldInstance(el);
      compileDynamicContent(el, binding.value, vnode.context);
    }
  },
  unbind(el) {
    destroyOldInstance(el);
  }
});

function destroyOldInstance(el) {
  if (el._dynamicInstance) {
    el._dynamicInstance.$destroy();
    el.innerHTML = '';
    delete el._dynamicInstance;
  }
}

function sanitizeAndFixHtml(html) {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['div', 'p', 'span', 'button', 'input', 'a'], // 扩展允许的标签
    ALLOWED_ATTR: ['style', 'class', 'v-if', 'v-for', '@click', ':class', ':style'], // 允许 Vue 指令和绑定
    FORBID_ATTR: ['src', 'href'] // 禁止潜在危险属性（如需启用链接，需额外处理）
  });
}

function compileDynamicContent(el, template, context) {
  const fixedHtml = sanitizeAndFixHtml(template);
  
  // 创建动态组件，继承父组件的数据和方法
  const DynamicComponent = Vue.extend({
    template: `<div>${fixedHtml}</div>`, // 包裹根元素避免解析错误
    data() {
      return { ...context.$data }; // 浅拷贝父组件数据（避免响应式冲突）
    },
    methods: { ...context.$options.methods }, // 继承方法
    computed: { ...context.$options.computed }, // 继承计算属性
    // 注入父组件的 $props 和 $listeners（可选）
    props: { ...context.$options.props },
    mounted() {
      // 可选：触发父组件事件（如 `this.$emit('compiled')`）
    },
  });

  const instance = new DynamicComponent().$mount();
  el.appendChild(instance.$el);
  el._dynamicInstance = instance;
}